import { useMemo } from 'react'

import { getTaskLogTextParts } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return [
      ...data.tasks_audit_logs
        //filter out legacy task audit logs
        .filter(log => !log.metadata.message)
        .map(({ type, metadata, created_at, id }) => ({
          id,
          type: 'log',
          date: created_at, // keep used for sorting.
          textParts: getTaskLogTextParts({
            type,
            metadata,
            created_at,
            actor: `${metadata?.user || 'Support'}`,
          }),
        })),
      // non-log special cases
      ...data.tasks_comments.map(
        ({ id, value, created_at, created_by_user }) => ({
          id,
          type: 'comment',
          author: `${created_by_user?.vaxiom_person?.first_name || 'Support'} ${
            created_by_user?.vaxiom_person?.last_name || ''
          }`,
          date: created_at,
          text: value,
        })
      ),
      {
        id: data.tasks_tasks_by_pk.id,
        type: 'creation',
        date: data.tasks_tasks_by_pk.created_at,
        author: `${
          data.tasks_tasks_by_pk.created_by_user?.vaxiom_person?.first_name ||
          'Support'
        } ${data.tasks_tasks_by_pk.created_by_user?.vaxiom_person?.last_name || ''}`,
      },
    ].sort((a, b) => new Date(b.date) - new Date(a.date))
  }, [data])
}
